import * as React from "react";

const IconReorder: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="currentColor">
            <path
                fill="currentColor"
                d="M0,6.5625 L0,6 L0,2.25 L0,1.6875 L0.5625,1.6875 L7.125,1.6875 L7.125,1.125 L7.125,0 L8.25,0 L9.70546889,1.45546889 L10.5,2.25 L9.70546889,3.04453111 L8.25,4.5 L7.125,4.5 L7.125,3.375 L7.125,2.8125 L1.125,2.8125 L1.125,6 L1.125,6.5625 L0,6.5625 Z M8.25,2.90859389 L8.90859389,2.25 L8.25,1.59140611 L8.25,2.90859389 Z M11.9999996,5.4375 L11.9999996,6 L11.9999996,9.75 L11.9999996,10.3125 L11.4375,10.3125 L4.875,10.3125 L4.875,10.875 L4.875,12 L3.75,12 L2.29453111,10.5445311 L1.49999964,9.75 L2.29453111,8.95546889 L3.75,7.5 L4.875,7.5 L4.875,8.625 L4.875,9.1875 L10.875,9.1875 L10.875,6 L10.875,5.4375 L11.9999996,5.4375 Z M3.75,10.4085939 L3.75,9.09140611 L3.09140611,9.75 L3.75,10.4085939 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(IconReorder);
